<template>
  <div class="score-ring" :class="{ 'score-ring--dark': dark }" :style="{ width: `${size}px`, height: `${size}px` }">
    <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" role="img" :aria-label="label">
      <circle :cx="centre" :cy="centre" :r="radius" fill="none" class="score-ring-track" :stroke-width="stroke" />
      <circle
        :cx="centre"
        :cy="centre"
        :r="radius"
        fill="none"
        :style="{ stroke: `var(--ex-score-${level})` }"
        :stroke-width="stroke"
        stroke-linecap="round"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="circumference * (1 - fraction)"
        :transform="`rotate(-90 ${centre} ${centre})`"
      />
    </svg>
    <div class="score-ring-text" aria-hidden="true">
      <span class="score-ring-figure" :style="{ fontSize: `${Math.round(size * 0.3)}px` }">{{ formatted }}</span>
      <span class="score-ring-caption" :style="{ fontSize: `${Math.max(12, Math.round(size * 0.08))}px` }">out of 10</span>
    </div>
  </div>
</template>

<script>
import { formatScore, getScoreLevel } from '../score/report.mjs'

export default {
  name: 'ScoreRing',
  props: {
    score: { type: [Number, String], required: true },
    // Grade label for screen readers, for example "Fair".
    grade: { type: String, default: '' },
    size: { type: Number, default: 200 },
    stroke: { type: Number, default: 16 },
    dark: { type: Boolean, default: false }
  },
  computed: {
    formatted () {
      return formatScore(this.score)
    },
    level () {
      return getScoreLevel(this.score)
    },
    centre () {
      return this.size / 2
    },
    radius () {
      return (this.size - this.stroke) / 2
    },
    circumference () {
      return 2 * Math.PI * this.radius
    },
    fraction () {
      return Math.min(Math.max(Number.parseFloat(this.score) / 10, 0), 1)
    },
    label () {
      return `Score ${this.formatted} out of 10${this.grade ? `, ${this.grade}` : ''}`
    }
  }
}
</script>

<style scoped>
.score-ring {
  position: relative;
  flex: none;
}

.score-ring svg {
  display: block;
}

.score-ring-track {
  stroke: var(--ex-color-hairline);
}

.score-ring--dark .score-ring-track {
  stroke: var(--ex-color-on-dark-subtle);
}

.score-ring-text {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.score-ring-figure {
  font-family: var(--ex-font-heading);
  font-weight: 600;
  letter-spacing: -0.04em;
  line-height: 1;
  color: var(--ex-color-dark);
}

.score-ring--dark .score-ring-figure {
  color: var(--ex-color-white);
}

.score-ring-caption {
  margin-top: 4px;
  color: var(--ex-color-neutral-500);
}

.score-ring--dark .score-ring-caption {
  color: var(--ex-color-neutral-300);
}
</style>
